// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/Pagination.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/Pagination.tsx");
}
// REMIX HMR END

import { Link } from '@remix-run/react';
import { useMemo } from 'react';
import cn from './Pagination.module.css';
export function Pagination({
  currentPage,
  pageCount,
  additionalParams = {}
}) {
  _s();
  const pageList = useMemo(() => {
    const allPageList = new Array(pageCount).fill(0).map((_, i) => i + 1);
    //最初のページ、最後のページ、現在のページの前後2ページを表示する
    return allPageList.reduce((prev, curr) => {
      function addNull(p, c) {
        const last = p[p.length - 1];
        if (last && c - last > 1) {
          return [...p, null, c];
        } else {
          return [...p, c];
        }
      }
      if (curr === 1) {
        return prev;
      }
      if (curr === currentPage - 2 || curr === currentPage - 1 || curr === currentPage || curr === currentPage + 1 || curr === currentPage + 2) {
        return addNull(prev, curr);
      }
      if (curr === pageCount) {
        return addNull(prev, curr);
      }
      return prev;
    }, [1]);
  }, [pageCount, currentPage]);
  return <div className={cn.Pagination}>
      {currentPage === 1 ? <span>prev</span> : <Link key="prev" to={generateParams(additionalParams, currentPage - 1)}>
          prev
        </Link>}


      {pageList.map(page => {
      if (page === null) {
        return <span key={page}>...</span>;
      }
      if (page === currentPage) {
        return <span key={page}>{page}</span>;
      }
      return <Link key={page} to={generateParams(additionalParams, page)}>
            {page}
          </Link>;
    })}

      {currentPage === pageCount ? <span>next</span> : <Link key="next" to={generateParams(additionalParams, currentPage + 1)}>
          next
        </Link>}

    </div>;
}
_s(Pagination, "jt4jvyyGan3oj4X2NyxCUcdABw4=");
_c = Pagination;
function generateParams(baseParams, page) {
  return `?${new URLSearchParams({
    ...baseParams,
    page: `${page}`
  }).toString()}`;
}
var _c;
$RefreshReg$(_c, "Pagination");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;